const FastCard = ({
  values,
  setConfirmSelect,
  onClickCard,
}: {
  values: any;
  setConfirmSelect?: (val: any) => void;
  onClickCard?: (values: any) => void;
}) => {
  const handleClick = () => {
    if (onClickCard) onClickCard(values);
    if (setConfirmSelect) setConfirmSelect({ modal: true, card: values });
  };

  return (
    <div
      className={`cardFast`}
      onClick={handleClick}
    >
      <div className="contentRow">
        <span className="card_numerFast">TARJETA</span>
        <span className="card_numerFast">
          Vence {values[4]}/{values[5]}
        </span>
      </div>
      <div className="contentRow">
        <span className="card_numerFast">{values[1].toUpperCase()}</span>
        <span className="card_numerFast">**** {values[2].slice(-4)}</span>
      </div>
    </div>
  );
};

export default FastCard;
